import React, { ReactNode } from 'react';
import { IsVisibleFunc } from '../uibuilder/form';

import styles from './Right.module.scss';

export interface LeftProps {
  children: ReactNode;
  className?: string;
  maxWidth?: number,
  // eslint-disable-next-line react/no-unused-prop-types
  isVisible?: IsVisibleFunc;
}

export default function Right({
  children,
  className,
  maxWidth,
}: LeftProps) {
  return (
    <div
      className={`${styles.right} ${className}`}
      style={{
        maxWidth: maxWidth ? `${maxWidth}%` : undefined,
      }}
    >
      {children}
    </div>
  );
}
